import * as React from "react";

import theme from "@ui/themes/default";

import { style, Icon } from "./Symbolicons";

export const Sunrise = (props: Icon): React.ReactElement => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    style={{ ...style(props.size, props.height), ...props.style }}
  >
    <g
      stroke={props.color || theme.palette.grey600}
      strokeWidth="2"
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M6.455 21a4.545 4.545 0 119.09 0M21 16.858l-4.166-1.691L15.167 11m0 0L11 12.667 6.834 11m0 0l-1.667 4.167L1 16.857m0 0L2.667 21m16.667 0L21 16.858M11 1L7.364 4.636M11 8.273V1M14.637 4.636L11 1" />
    </g>
  </svg>
);
